<template>
  <div class="now-play">
    <span class="np-action">{{ event }}</span>
    <span class="np-title">{{ currentAudio.title }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PlayerStatus',
  computed: {
    ...mapState(['event', 'currentAudio'])
  }
}
</script>

<style>
.now-play {
  display:block;
  font-size:0;
}

.now-play span {
  display:inline-block;
  font-size:1.05rem;
  vertical-align:top;
  padding:21px;
}

.np-action {
  width:30%;
}

.np-title {
  text-align:right;
  width:70%;
}

/* Media Queries
================================================== */

@media only screen and (max-width:600px) {
  .now-play .np-action { display:none; }
  .now-play .np-title { display:block; text-align:center; width:100%; }
}
</style>



// WEBPACK FOOTER //
// src/components/PlayerStatus.vue